<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Consulta de Solicitudes de Actualización de Beneficiarios" description="" />
      <BeneficiarieUpdateRequests/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import BeneficiarieUpdateRequests from '@/components/Beneficiarie/BeneficiarieUpdateRequests.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {

    }
  },
  name: 'BeneficiarieUpdateRequestsView',
  components: {
    Header,
    BeneficiarieUpdateRequests,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>